import { analytics, ReactivateBannerEvents } from '@/lib/analytics'

interface ReactivateBannerEventData {
  source: 'dashboard' | 'sidebar' | 'mobile-banner'
  planFeature: string
}

export function trackReactivateBannerViewed(
  data: ReactivateBannerEventData,
): void {
  analytics.track(ReactivateBannerEvents.VIEWED, {
    source: data.source,
    plan_feature: data.planFeature,
  })
}

export function trackReactivateBannerClicked(
  data: ReactivateBannerEventData,
): void {
  analytics.track(ReactivateBannerEvents.CLICKED, {
    source: data.source,
    plan_feature: data.planFeature,
  })
}
